import React, { Component } from "react";
import "rc-collapse/assets/index.css";
import Collapse, { Panel } from "rc-collapse";
import { ListGroup, Button, Modal, Form, Row, Col, Alert } from "react-bootstrap";
import {
  ListarCorredores,
  CadastrarCorredor,
  EditarCorredor,
  DeletarCorredor,
} from "../../providers/CorredoresProvider";
import {
  CadastrarCategoria,
  EditarCategoria,
  DeletarCategoria,
} from "../../providers/CategoriasProdutoProvider";
import { getUser } from "../../services/Auth";
import { toast } from "react-toastify";

export default class CorredoresCategorias extends Component {
  constructor(props) {
    super(props);
    this.state = {
      corredores: [],
      categorias: [],
      corredorNome: "",
      corredorImagem: "",
      categoriaNome: "",
      categoriaNomeForm: "",
      id_corredor: "",
      id_categoria: "",
      categoriaProdutosLength: null,
      corredorCategoriasLength: null,
      showModalCorredor: false,
      showModalCategoria: false,
      showModalAlert: false,
      errorCadastro: "",
      modoEditarCorredor: false,
      modoEditarCategoria: false,
      modoDeletarCategoria: false,
      showAlert: false,
      mensagemAlert: "",
      variantAlert: "",
    };
  }

  handleCloseModalCorredor = () => {
    this.setState({ showModalCorredor: false });
    this.limparForm();
  };

  handleShowModalCorredor = () => {
    this.setState({ showModalCorredor: true });
  };

  handleShowModalCategoria = (data, isEdit) => {
    if (isEdit) {
      if (data) {
        this.setState({
          showModalCategoria: true,
          id_categoria: data._id,
          modoEditarCategoria: isEdit,
        });
      } else {
        this.setState({ showModalCategoria: true, modoEditarCategoria: isEdit });
      }
    } else {
      this.setState({
        showModalCategoria: true,
        id_corredor: data._id,
        modoEditarCategoria: isEdit,
      });
    }
  };

  handleCloseModalCategoria = () => {
    this.setState({ showModalCategoria: false });
    this.limparForm();
  };

  handleCloseModalAlert = () => {
    this.setState({ showModalAlert: false });
    this.limparForm();
  };

  handleShowModalAlert = (data, isCorredor) => {
    if (isCorredor) {
      this.setState({ showModalAlert: true, id_corredor: data._id });
    } else {
      this.setState({
        showModalAlert: true,
        id_categoria: data._id,
        modoDeletarCategoria: true,
      });
    }
  };

  handleShowAlert = (mensagem, variant) => {
    if (variant === "success") {
      toast.success(mensagem);
    } else {
      toast.error(mensagem);
    }
  };

  adicionarCategoria = () => {
    let categoria = {};
    categoria.nome = this.state.categoriaNome;
    if (categoria.nome !== "") {
      categoria.id = new Date().getTime();
      let categorias = this.state.categorias;
      categorias.push(categoria);
      this.setState({ categorias, categoriaNome: "" });
    }
  };

  limparForm = () => {
    this.setState({
      categorias: [],
      corredorNome: "",
      corredorImagem: "",
      categoriaNome: "",
      categoriaNomeForm: "",
      id_corredor: "",
      id_categoria: "",
      categoriaProdutosLength: null,
      corredorCategoriasLength: null,
      showModalCorredor: false,
      showModalCategoria: false,
      showModalAlert: false,
      errorCadastro: "",
      modoEditarCorredor: false,
      modoEditarCategoria: false,
      modoDeletarCategoria: false,
    });
  };

  preencherFormCorredor = async (corredor) => {
    this.setState({
      corredorNome: corredor.nome,
      categorias: corredor.categorias,
      modoEditarCorredor: true,
      id_corredor: corredor._id,
      corredorCategoriasLength: corredor.categorias.length,
    });
    this.handleShowModalCorredor();
  };

  preencherFormCategoria = async (categoria) => {
    this.setState({
      categoriaNomeForm: categoria.nome,
      categoriaProdutosLength: 0,
      id_categoria: categoria._id,
    });
    this.handleShowModalCategoria(null, true);
  };

  editarCorredor = async () => {
    let form = {
      nome: this.state.corredorNome,
    };
    if (!this.state.corredorNome) {
      this.setState({ errorCadastro: "Informções obrigatórias faltando" });
    } else {
      try {
        const response = await EditarCorredor(form, this.state.id_corredor);
        if (response) {
          this.limparForm();
          await this.ListarCorredores();
          this.handleShowAlert("Corredor editado com sucesso", "success");
        }
      } catch (error) {
        this.handleShowAlert(error.error, "danger");
      }
    }
  };

  editarCategoria = async () => {
    let data = {
      nome: this.state.categoriaNomeForm,
    };
    try {
      const response = await EditarCategoria(data, this.state.id_categoria);
      if (response) {
        this.limparForm();
        await this.ListarCorredores();
        this.handleShowAlert("Categoria editada com sucesso", "success");
      }
    } catch (error) {
      this.handleShowAlert(error.error, "danger");
    }
  };

  deletarCorredor = async () => {
    try {
      const response = await DeletarCorredor(this.state.id_corredor);
      if (response) {
        this.limparForm();
        await this.ListarCorredores();
        this.handleShowAlert("Corredor excluido com sucesso", "success");
      }
    } catch (error) {
      this.handleShowAlert(error.error, "danger");
    }
  };

  deletarCategoria = async () => {
    try {
      const response = await DeletarCategoria(this.state.id_categoria);
      if (response) {
        this.limparForm();
        await this.ListarCorredores();
        this.handleShowAlert("Categoria excluida com sucesso", "success");
      }
    } catch (error) {
      this.handleShowAlert(error.error, "danger");
    }
  };

  cadastrarCategoria = async () => {
    let user = await getUser();
    if (!this.state.categoriaNomeForm) {
      this.setState({ errorCadastro: "Informções obrigatórias faltando" });
    } else {
      let data = {
        nome: this.state.categoriaNomeForm,
        corredor: this.state.id_corredor,
        estabelecimento: user.estabelecimento._id,
      };
      try {
        const response = await CadastrarCategoria(data);
        if (response) {
          this.limparForm();
          await this.ListarCorredores();
          this.handleShowAlert("Categoria cadastrada com sucesso", "success");
        }
      } catch (error) {
        this.handleShowAlert(error.error, "danger");
      }
    }
  };

  cadastrarCorredor = async () => {
    let user = await getUser();
    let categorias = this.state.categorias;
    if (!this.state.corredorNome) {
      this.setState({ errorCadastro: "Informções obrigatórias faltando" });
    } else {
      categorias.forEach((item, i) => {
        item.id = undefined;
        item.estabelecimento = user.estabelecimento._id;
      });
      let form = {
        nome: this.state.corredorNome,
        estabelecimento: user.estabelecimento._id,
        categorias: categorias,
      };
      try {
        const response = await CadastrarCorredor(form);
        if (response) {
          this.limparForm();
          await this.ListarCorredores();
          this.handleShowAlert("Corredor cadastrado com sucesso", "success");
        }
      } catch (error) {
        this.handleShowAlert(error.error, "danger");
      }
    }
  };

  removerCategoria = (index) => {
    let categorias = this.state.categorias;
    delete categorias[index];
    this.setState({ categorias });
  };

  ListarCorredores = async () => {
    const response = await ListarCorredores();
    this.setState({ corredores: response });
  };

  async componentDidMount() {
    await this.ListarCorredores();
  }

  render() {
    return (
      <div>
        {this.state.showAlert ? (
          <Alert style={{ zIndex: 99999999999 }} variant={this.state.variantAlert}>
            {this.state.mensagemAlert}
          </Alert>
        ) : null}
        <br></br>
        <Row>
          <Col md={9}>
            <h3>Corredores e Categorias</h3>
          </Col>
          <Col>
            {
              <Button
                onClick={() => {
                  this.handleShowModalCorredor();
                }}
              >
                Cadastrar corredor
              </Button>
            }
          </Col>
        </Row>
        <br></br>
        {this.state.corredores.length ? (
          <div style={{ maxHeight: 580, overflow: "auto" }}>
            <Collapse accordion={true}>
              {this.state.corredores.map((corredor, i) => {
                return (
                  <Panel
                    key={i}
                    header={
                      <Row md={12} style={{ width: "100%" }}>
                        <Col md={10}>
                          <h5 style={{ marginTop: 10 }}>
                            {corredor.nome}
                            <span
                              style={{
                                marginLeft: 8,
                                fontSize: 14,
                                fontWeight: "normal",
                              }}
                            >
                              ({corredor.categorias.length}) categorias
                            </span>
                          </h5>
                        </Col>
                        <Col md={1}>
                          {
                            <Button
                              size="sm"
                              variant="info"
                              onClick={() => this.preencherFormCorredor(corredor)}
                            >
                              Editar
                            </Button>
                          }
                        </Col>
                        <Col md={1}>
                          {
                            <Button
                              size="sm"
                              variant="danger"
                              onClick={() => {
                                this.handleShowModalAlert(corredor, true);
                              }}
                            >
                              Excluir
                            </Button>
                          }
                        </Col>
                      </Row>
                    }
                  >
                    {corredor.categorias.length ? (
                      <ListGroup key={i}>
                        <Row md={12} style={{ width: "100%" }}>
                          <Col md={10}>
                            <h5>Categorias</h5>
                          </Col>
                          <Col md={2}>
                            {
                              <Button
                                size="sm"
                                onClick={() => {
                                  this.handleShowModalCategoria(corredor, false);
                                }}
                              >
                                Adicionar categoria
                              </Button>
                            }
                          </Col>
                        </Row>
                        <br></br>
                        {corredor.categorias.map((categoria, j) => {
                          return (
                            <ListGroup.Item key={j}>
                              <Row>
                                <Col>
                                  <p style={{ fontWeight: "bold" }}>{categoria.nome}</p>
                                  {categoria.produtos ? (
                                    <span
                                      style={{
                                        marginLeft: 8,
                                        fontSize: 14,
                                        fontWeight: "normal",
                                      }}
                                    >
                                      (
                                      {categoria.produtos ? categoria.produtos.length : 0}
                                      ) produtos
                                    </span>
                                  ) : null}
                                </Col>
                                <Col md={1}>
                                  {
                                    <Button
                                      size="sm"
                                      variant="info"
                                      onClick={() => {
                                        this.preencherFormCategoria(categoria);
                                      }}
                                    >
                                      Editar
                                    </Button>
                                  }
                                </Col>
                                <Col md={1}>
                                  {
                                    <Button
                                      size="sm"
                                      variant="danger"
                                      onClick={() => {
                                        this.handleShowModalAlert(categoria, false);
                                      }}
                                    >
                                      Excluir
                                    </Button>
                                  }
                                </Col>
                              </Row>
                            </ListGroup.Item>
                          );
                        })}
                      </ListGroup>
                    ) : (
                      <Row>
                        <Col md={9}>
                          <p>Nenhuma categoria cadastrada</p>
                        </Col>
                        <Col md={3}>
                          {
                            <Button
                              size="sm"
                              onClick={() => {
                                this.handleShowModalCategoria(corredor, false);
                              }}
                            >
                              Cadastrar categoria
                            </Button>
                          }
                        </Col>
                      </Row>
                    )}
                  </Panel>
                );
              })}
            </Collapse>
          </div>
        ) : (
          <div>
            <h5>Nenhum corredor cadastrado</h5>
          </div>
        )}

        <Modal
          size="lg"
          show={this.state.showModalCorredor}
          onHide={this.handleCloseModalCorredor}
        >
          <Modal.Header closeButton className="modalHeader">
            <Modal.Title>
              {this.state.modoEditarCorredor ? "Editar Corredor" : "Cadastrar Corredor"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.errorCadastro ? (
              <div>
                <p style={{ color: "red" }}>{this.state.errorCadastro}</p>
              </div>
            ) : null}
            <Form>
              <Form.Group controlId="formCorredor">
                <Form.Label>Nome *</Form.Label>
                <Form.Control
                  value={this.state.corredorNome}
                  type="text"
                  placeholder="Nome do corredor"
                  onChange={(e) => {
                    this.setState({ corredorNome: e.target.value });
                  }}
                />
              </Form.Group>
              {!this.state.modoEditarCorredor ? (
                <Form.Group controlId="formCorredor">
                  <Form.Label>Adicionar categoria</Form.Label>
                  <Row>
                    <Col>
                      <Form.Control
                        type="text"
                        placeholder="Nome da categoria"
                        value={this.state.categoriaNome}
                        onChange={(e) => {
                          this.setState({ categoriaNome: e.target.value });
                        }}
                      />
                    </Col>
                    <Col>
                      <Button onClick={this.adicionarCategoria}>Adicionar</Button>
                    </Col>
                  </Row>
                  <Row>
                    {this.state.categorias.map((item, i) => {
                      return (
                        <ListGroup
                          key={i}
                          style={{ marginLeft: 25, marginTop: 5, padding: 5 }}
                        >
                          <ListGroup.Item key={i}>
                            {item.nome}
                            <Button
                              size="sm"
                              variant="danger"
                              style={{ marginLeft: 5 }}
                              onClick={() => this.removerCategoria(i)}
                            >
                              X
                            </Button>
                          </ListGroup.Item>
                        </ListGroup>
                      );
                    })}
                  </Row>
                </Form.Group>
              ) : (
                <p>Quantidade de categorias: {this.state.corredorCategoriasLength}</p>
              )}
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                this.handleCloseModalCorredor();
              }}
            >
              Fechar
            </Button>
            {this.state.modoEditarCorredor ? (
              <Button
                variant="primary"
                onClick={() => {
                  this.editarCorredor();
                }}
              >
                {"Editar"}
              </Button>
            ) : (
              <Button
                variant="primary"
                onClick={() => {
                  this.cadastrarCorredor();
                }}
              >
                {"Cadastrar"}
              </Button>
            )}
          </Modal.Footer>
        </Modal>

        <Modal
          size="lg"
          show={this.state.showModalCategoria}
          onHide={this.handleCloseModalCategoria}
        >
          <Modal.Header closeButton className="modalHeader">
            <Modal.Title>
              {this.state.modoEditarCategoria
                ? "Editar Categoria"
                : "Cadastrar Categoria"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.errorCadastro ? (
              <div>
                <p style={{ color: "red" }}>{this.state.errorCadastro}</p>
              </div>
            ) : null}
            <Form>
              <Form.Group controlId="formCorredor">
                <Form.Label>Nome *</Form.Label>
                <Form.Control
                  value={this.state.categoriaNomeForm}
                  type="text"
                  placeholder="Nome da categoria"
                  onChange={(e) => {
                    this.setState({ categoriaNomeForm: e.target.value });
                  }}
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                this.handleCloseModalCategoria();
              }}
            >
              Fechar
            </Button>
            {this.state.modoEditarCategoria ? (
              <Button
                variant="primary"
                onClick={() => {
                  this.editarCategoria();
                }}
              >
                Editar
              </Button>
            ) : (
              <Button
                variant="primary"
                onClick={() => {
                  this.cadastrarCategoria();
                }}
              >
                Cadastrar
              </Button>
            )}
          </Modal.Footer>
        </Modal>

        <Modal
          size="sm"
          show={this.state.showModalAlert}
          onHide={this.handleCloseModalAlert}
        >
          <Modal.Header closeButton>
            <Modal.Title>Alerta</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {this.state.modoDeletarCategoria ? (
              <p>Deseja realmente excluir a categoria?</p>
            ) : (
              <p>Deseja realmente excluir o corredor?</p>
            )}
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                this.handleCloseModalAlert();
              }}
            >
              Não
            </Button>
            {this.state.modoDeletarCategoria ? (
              <Button
                variant="primary"
                onClick={() => {
                  this.deletarCategoria();
                }}
              >
                Sim
              </Button>
            ) : (
              <Button
                variant="primary"
                onClick={() => {
                  this.deletarCorredor();
                }}
              >
                Sim
              </Button>
            )}
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
